import { reaction } from 'mobx';
import { awaitTo } from '../../utils/tools';
import referIndexDB from '../../utils/cache';

export default function (rootStore: any) {
  const { referInputProps } = rootStore
  const actionsObj: any = {}

  if (['Table'].includes(rootStore.refEntity.cTpltype)) {
    // 请求数据
    actionsObj.getRefData = reaction(() => rootStore.referStore.searchFlag, async (newVal: any, oldVal: any) => {
      if (newVal.type === 'smartSearch') return
      const [res] = await awaitTo(rootStore.actions.getRefData.doAction(), { errMsg: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1BAEC6D805D00019', '获取数据错误') }, referInputProps)
      rootStore.tableStore.setValue(res?.recordList || [])
      if (res) {
        const { recordCount } = res
        rootStore.pagingStore.setPageTotal(recordCount)
      }
    })
  } else if (['Tree'].includes(rootStore.refEntity.cTpltype)) {
    // 请求数据
    actionsObj.getRefData = reaction(() => rootStore.referStore.searchFlag, async (newVal: any, oldVal: any) => {
      if (newVal.type === 'smartSearch') return
      const [res] = await awaitTo(rootStore.actions.getRefData.doAction(), { errMsg: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1BAEC6D805D00019', '获取数据错误') }, referInputProps)
      rootStore.treeStore.setValue(res || [])
    })

    // 单选树选择时保留一个数据
    actionsObj.selectedKeys = reaction(() => rootStore.treeStore?.getSelectedKeys(), (newVal: any) => {
      if (newVal.length > 1 && !referInputProps.multiple) {
        newVal.shift()
      }
    })
  } else if (['TreeTable'].includes(rootStore.refEntity.cTpltype)) {
    // 请求数据
    actionsObj.getRefData = reaction(() => rootStore.referStore.searchFlag, async (newVal: any, oldVal: any) => {
      if (newVal.type === 'smartSearch') return
      if (newVal.type === 'init') { // 初始化数据
        let [res] = await awaitTo(rootStore.actions.getRefData.doAction({ type: 'leftTree' }), { errMsg: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1BAEC6D805D00018', '获取树数据错误') }, referInputProps)
        if (res) {
          const textField = rootStore.refEntity.cDataClass_lsName || rootStore.referInputProps.textField
          res = [{
            [rootStore.cEntityKeyFld]: 'all',
            [textField]: rootStore.topName,
            children: [...res]
          }]
          rootStore.treeStore.setValue(res)
        }
      }
      // 右表数据查询 + 弹窗搜索数据
      const [res] = await awaitTo(rootStore.actions.getRefData.doAction(), { errMsg: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1BAEC6D805D00016', '获取表数据错误') }, referInputProps)
      rootStore.pagingStore.setPageTotal(res?.recordCount ?? 0)
      rootStore.tableStore.setValue(res?.recordList || [])
    })

    // 左树选择
    actionsObj.treeSelect = reaction(() => rootStore.treeStore.selectedKeys, async (newVal: any, oldVal: any) => {
      const path: string = newVal[0] === 'all' ? '' : (rootStore.treeStore.getSelectedNodes()[0]?.path || newVal[0])
      rootStore.searchData({ type: 'search', params: { path: path } })
    })
  } else { // 默认
    actionsObj.getRefData = reaction(() => rootStore.referStore.searchFlag, async (newVal: any, oldVal: any) => {
      console.error('参照类型不支持');
    })
  }

  // 扩展钩子--分页修改
  if (['Table', 'TreeTable'].includes(rootStore.refEntity.cTpltype)) {
    // 值改变的响应监听---看是否加上
    actionsObj.onChangeSelect = reaction(() => rootStore.tableStore.getSelectedRows(), async (newVal: any, oldVal: any) => {
      await referInputProps.onChangeSelect?.({ oldValue: oldVal, currentValue: newVal })
    })

    actionsObj.pagingChange = reaction(() => rootStore.referStore.getValue('requestData.page'), async (newVal: any, oldVal: any) => {
      if (newVal.pageSize === oldVal.pageSize && newVal.pageIndex === oldVal.pageIndex) return
      await referInputProps.onChangePageIndex?.(newVal) // 钩子
      const { domainKey, serviceCode, billNo, refCode, subuiType } = referInputProps
      subuiType !== 'drop' &&  referIndexDB.setCache(`pageinfo_${serviceCode}_${domainKey}_${billNo}_${refCode}`, { ...newVal })

      rootStore.pagingStore.setPageInfo({ pageIndex: newVal.pageIndex, pageSize: newVal.pageSize })
    })

    rootStore.pagingStore && (rootStore.pagingStore.hooks.checkChange = (pageInfo: any) => {
      const page = { pageIndex: pageInfo.pageIndex, pageSize: pageInfo.pageSize }
      rootStore.searchData({ type: 'search', params: { page } })
    })
  } else if (['Tree'].includes(rootStore.refEntity.cTpltype)) {
    // 值改变的响应监听
    actionsObj.onChangeSelect = reaction(() => rootStore.treeStore.getSelectedNodes(), async (newVal: any, oldVal: any) => {
      await referInputProps.onChangeSelect?.({ oldValue: oldVal, currentValue: newVal })
      // rootStore.referStore.search() // ???没用
    })
  }

  return {
    ...actionsObj,
    //  智能搜索
    smartSearch: reaction(() => rootStore.referStore.searchFlag, async (newVal: any, oldVal: any) => {
      if (newVal.type === 'smartSearch') { // 智能搜索
        const smartData = rootStore.referStore.getValue('smartSearchData')
        const [res] = await awaitTo(rootStore.actions.getRefData.doAction( { requestData: smartData }), { errMsg: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1BAEC6D805D00017', '智能搜索获取数据错误') }, referInputProps)
        res && rootStore.smartSearchStore.setValue(res.recordList || res)
      }
      rootStore.referStore.searchFlag.type = ''
    }),

    // 显示停用
    stopShow: reaction(() => rootStore.referStore.stopShow, async (newVal: any, oldVal: any) => {
      rootStore.searchData({ type: 'search', params: { stopShow: newVal } })
    }),

    // 新增编辑弹窗关闭时间
    dialogStack: reaction(() => rootStore.pageStore.dialogStack?.length, async (newVal: any, oldVal: any) => {
      if (newVal < oldVal && newVal === 0) {
        rootStore.searchData({ type: 'search', params: { likeValue: '', path: undefined } })
      }
    }),

    // 查询区搜索
    filterSearch: reaction(() => rootStore.filterStore?.queryTrigger, async (newVal: any) => {
      // const { conditions } = rootStore.filterStore?.getQueryCondition()
      // const simpleVOs = conditions.map((item: any) => ({
      //   logicOp: item.op,
      //   conditions: item.items.map((e: any) => ({
      //     field: e.name, op: e.op, value1: e.v1,value2: e.v2
      //   }))
      // }))
      // rootStore.searchData({ type: 'search', params: { filterCondition: { isExtend: true, simpleVOs }, likeValue: undefined } })
      rootStore.searchData({ type: 'search' })
    })

  }
}
